import TiptapImage, { type ImageOptions as TiptapImageOptions } from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ImageView } from './views/ImageView';

export interface ImageOptions extends TiptapImageOptions {
  translations?: Record<string, string>;
}

export const Image = TiptapImage.extend<ImageOptions>({
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      ...this.parent?.(),
      blobKey: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-blob-key'),
        renderHTML: (attributes) => {
          if (!attributes.blobKey) return {};
          return { 'data-blob-key': attributes.blobKey };
        },
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageView);
  },
});
